export function formatTopPercentDisplay(rank, total) {
  const rankNumber = Number(rank);
  const totalNumber = Number(total);
  if (!Number.isFinite(rankNumber) || rankNumber <= 0 || !Number.isFinite(totalNumber) || totalNumber <= 0) {
    return "";
  }
  const percent = (rankNumber / totalNumber) * 100;
  if (percent > 0 && percent < 0.1) return "<0.1%";
  if (percent < 10) return `${percent.toFixed(1)}%`;
  return `${Math.round(percent)}%`;
}
